import { useEffect, useLayoutEffect, useState, type FC, type PropsWithChildren } from 'react'

import { useI18nContext, I18nContext } from '@/i18n/i18n-react'
import type { Locales, TranslationFunctions } from '@/i18n/i18n-types'
import { signal, useAsyncEffect, useEffectOn } from '@/react/core/reactive'

import { wsSendLocale } from '../websocket/ws-send'
import { secondDisplayLock } from '../websocket/ws-state'

//-> holder
export const [LL2, setLL2] = signal<TranslationFunctions>()
export const [locale, setLocale] = signal<Locales | undefined>()

export function getLL2(): () => TranslationFunctions {
  return LL2
}

const I18nBackend: FC<PropsWithChildren> = props => {
  const i18n = useI18nContext()
  const [shouldRender, setShouldRender] = useState<boolean>(false)
  useLayoutEffect(() => {
    setLL2(() => i18n.LL)
    setShouldRender(true)
  }, [i18n.locale])

  // Allow signal to change locale
  useEffectOn([locale], () => {
    const l = locale()
    if (l) i18n.setLocale(l)
  })

  useAsyncEffect(async () => {
    await secondDisplayLock.acquireAsync();
    if (i18n.locale) wsSendLocale(i18n.locale)
  }, [i18n.locale])

  return shouldRender ? <>{props.children}</> : null
}

export default I18nBackend
